interface CuidariRouteErrorProps {
  error: unknown
  reset?: () => void
}

function messageFrom(error: unknown): string {
  if (error instanceof Error && error.message.trim()) return error.message
  return 'Falha inesperada'
}

export function CuidariRouteError({ error, reset }: CuidariRouteErrorProps) {
  const detail = messageFrom(error)
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 20px',
        background: 'var(--color-bg, #f8fafc)',
      }}
    >
      <section
        role="alert"
        aria-live="assertive"
        style={{
          width: '100%',
          maxWidth: 420,
          borderRadius: 20,
          background: 'white',
          border: '1px solid var(--color-border, #e5e7eb)',
          boxShadow: '0 18px 48px rgba(15, 23, 42, 0.12)',
          padding: 24,
        }}
      >
        <p
          style={{
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'var(--color-primary, #0d9488)',
            marginBottom: 10,
          }}
        >
          Cuidari
        </p>
        <h1
          style={{
            fontSize: 24,
            lineHeight: 1.15,
            fontWeight: 900,
            color: '#111827',
            marginBottom: 8,
          }}
        >
          Essa tela precisa recarregar
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.55, color: '#64748b', marginBottom: 18 }}>
          Seus dados continuam protegidos. Tente abrir a tela novamente; se o erro
          continuar, vamos investigar pelo registro tecnico.
        </p>
        <p
          style={{
            fontSize: 11,
            lineHeight: 1.4,
            color: '#94a3b8',
            background: '#f8fafc',
            borderRadius: 12,
            padding: '10px 12px',
            marginBottom: 18,
            wordBreak: 'break-word',
          }}
        >
          {detail}
        </p>
        <button
          type="button"
          onClick={() => {
            if (reset) {
              reset()
            } else {
              window.location.reload()
            }
          }}
          style={{
            width: '100%',
            minHeight: 44,
            borderRadius: 14,
            border: 'none',
            background: 'var(--color-primary, #0d9488)',
            color: 'white',
            fontSize: 14,
            fontWeight: 800,
            cursor: 'pointer',
          }}
        >
          Tentar de novo
        </button>
      </section>
    </main>
  )
}
